export default function generateNewConnection({
  network,
  id,
  title = '',
  trayWizardUrl,
  triggerUrl,
  enabled = true,
  socialiveAvailable = true,
}) {
  return {
    id,
    network,
    title,
    trayWizardUrl,
    triggerUrl,
    enabled,
    socialiveAvailable,
  };
}
